﻿import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";

@NgComponent({
    token: Token.KbIcon,
    dependencies: [
        Token.KbService
    ]
})
export class KbIcon extends Directive {
    constructor(
        private kbService: KbService
    ) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-icon");
        this.scope = {
            icon: "@",
            label: "@"
        };
        this.replace = true;
    }
}
